











import { createComponent, ref } from "@vue/composition-api";

const authSettings: gapi.auth2.ClientConfig = {
  client_id: process.env.VUE_APP_GOOGLE_CLIENT_ID,
  scope: "profile email openid",
  hosted_domain: process.env.VUE_APP_GOOGLE_HOSTED_DOMAIN,
  ux_mode: "popup",
};

export default createComponent({
  setup(props, ctx) {
    const isInitComplete = ref(false);
    const isSignedIn = ref(false);

    gapi.load("auth2", () => {
      gapi.auth2.init(authSettings).then((auth) => {
        isInitComplete.value = true;
        isSignedIn.value = auth.isSignedIn.get();

        auth.isSignedIn.listen((status) => (isSignedIn.value = status));
      });
    });

    function signIn() {
      gapi.auth2.getAuthInstance().signIn();
    }

    return { isSignedIn, isInitComplete, signIn };
  },
});
